import React from 'react';
import ProjectCell from "./ProjectCell";

class ProjectRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = { unknownOffTime: false };
    }

    static formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    render() {
        const project = this.props.project;
        const days = this.props.days;
        const archived = project.archived;
        const workSessions = project.workSessions || [];
		
		var isFeestdagen = (project && project.name === "Feestdagen");

        // Totaal uren op deze rij bepalen
        var totalHours = 0;
        for (var t = 0; t < workSessions.length; t++) {
            var ws = workSessions[t];
            if (ws && ws.numberOfHours != null) {
                totalHours += Number(ws.numberOfHours) || 0;
            }
        }

        // Feestdagen-rij verbergen als er geen uren zijn
        if (isFeestdagen && totalHours === 0) {
            return null;
        }

		console.log("PROJECT:", project);
        // -----------------------------
        // CELLEN PER DAG
        // -----------------------------
        const cells = days.map(date => {
            const isoDate = ProjectRow.formatDate(date);
            let foundWorkSessions = null;

            for (let i = 0; i < workSessions.length; i++) {
                if (workSessions[i].date === isoDate) {
                    foundWorkSessions = workSessions[i];
                }
            }

            const freeDay = date.getDay() === 6 || date.getDay() === 0;

            return (
                <ProjectCell
                    key={isoDate}
                    archived={archived}
                    date={isoDate}
                    workSessions={foundWorkSessions}
                    freeDay={freeDay}
                    updateHolidaySaldo={this.updateHolidaySaldo.bind(this)}
                    customer={this.props.customer}
                    project={project}
                    onWorkSessionSaved={this.props.onWorkSessionSaved}
					isLoading={this.props.isLoading}
                    readOnly={isFeestdagen}
                />
            );
        });


        // -----------------------------
        // KLASSEN
        // -----------------------------
        let classes = "project-row first";

        if (archived) {
            classes += " archived";
        }
        if (project.category !== null && project.category !== "") {
            classes += " has-category";
        }
        if (this.props.className) {
            classes += " " + this.props.className;
        }

        // -----------------------------
        // CATEGORY TITLE
        // -----------------------------
        let title = null;
        if (this.props.displayCategoryTitle && project.category != null) {
            title = (
                <section className="project-category">
                    {project.category}
                </section>
            );
            classes += " includes-header";
        }

        // -----------------------------
        // WEEK TOTAL + statSpan (oude gedrag behouden)
        // -----------------------------
        let statSpan = null;
        let totalText = "";

        if (this.props.stats && this.props.stats.total != null && this.props.stats.total !== 0) {
            totalText = " (" + this.props.stats.total + ")";
            statSpan = (
                <span className="float-right strong grey-color p-r-xs">
                    {this.props.stats.total}
                </span>
            );
        }

        // -----------------------------
        // BUDGET (groen/rood)
        // -----------------------------
        let budget = null;

        // Nieuwe Mendix velden
		var budgetHours = (project.budget != null ? project.budget : 0);
		var budgetUsedHours = (project.budgetUsed != null ? project.budgetUsed : 0);

        // Totaal verbruik = gebruikt tot nu toe + deze week
        var usedTotal = budgetUsedHours

        if (budgetHours > 0) {
            var binnenBudget = (usedTotal <= budgetHours);
            var color = binnenBudget ? "success-color" : "error-color";

            budget = (
                <span className={"float-right strong p-l-xs " + color}>
                    {usedTotal} &nbsp;/&nbsp; {budgetHours}
                </span>
            );
        }

        const name = project.name;

        // -----------------------------
        // RENDER
        // -----------------------------
        return (
            <div className={classes}>
                {title}

                <div className="offset" title={name + totalText}>
                    {name}
                    {budget}
                    {statSpan}
                </div>

                <span className="clear-on-mobile" />

                {cells}
            </div>
        );
    }

    updateHolidaySaldo() {
        if (this.props.project.holiday) {
            this.props.updateHolidaySaldo();
        }
    }
}

export default ProjectRow;
